import React from 'react'
import {  TextField, FormControl } from "@material-ui/core";
import {styles} from './styles';

export const TextfieldBasic = ({inputRef, name, onChange, errors, value, label, inputProps, required, placeholder}) => {
    const classes = styles();
    return (
      
         <FormControl fullWidth  >
                      <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          className={classes.dropdown}
                          inputProps = {inputProps }
                          InputLabelProps={{ shrink: true }}
                          inputRef={inputRef}
                          label={label}
                          placeholder={placeholder}
                          onChange={onChange}
                          name={name}
                          required={required}
                          value={value}
                          error={errors.hasOwnProperty(name) && errors[name].message}
                          helperText={errors.hasOwnProperty(name) && errors[name].message}
    
                      />
                    </FormControl>   
    )
}

export const WithoutValidation = ({inputRef, name, onChange,  value, label}) => {
    return (
        <FormControl fullWidth>
                      <TextField
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          inputRef={inputRef}
                          label={label}
                          margin="normal"
                          onChange={onChange}
                          name={name}
                          value={value}
                      />
                    </FormControl>   
    )
}

export const TextfieldDisabled = ({inputRef, name, onChange,  value, label}) => {
    const classes = styles();
    return (
        <FormControl fullWidth>
                      <TextField
                          fullWidth
                          className={classes.dropdownMultiple}
                          variant="outlined"
                          disabled
                          defaultValue = ''
                          size = 'small'
                          InputLabelProps={{ shrink: true }}
                          inputRef={inputRef}
                          label={label}
                          name={name}
                          value={value}
                      />
                    </FormControl>   
    )
}

